import type { TypeCode } from './types'

export interface TypeColorConfig {
  primary: string      // 主色
  secondary: string    // 辅色
  text: string         // 文字色（在主色背景上）
  group: 'AS' | 'AC' | 'RS' | 'RC'
  groupName: string
}

export const TYPE_COLORS: Record<TypeCode, TypeColorConfig> = {
  // AS组（冷蓝灰+墨色）- 独立探索
  ASID: { primary: '#334155', secondary: '#1e293b', text: '#ffffff', group: 'AS', groupName: '独立探索' },
  ASIO: { primary: '#475569', secondary: '#1e293b', text: '#ffffff', group: 'AS', groupName: '独立探索' },
  ASED: { primary: '#334155', secondary: '#1e293b', text: '#ffffff', group: 'AS', groupName: '独立探索' },
  ASEO: { primary: '#475569', secondary: '#1e293b', text: '#ffffff', group: 'AS', groupName: '独立探索' },

  // AC组（紫色层次）- 独立创造
  ACID: { primary: '#4c1d95', secondary: '#7c3aed', text: '#ffffff', group: 'AC', groupName: '独立创造' },
  ACIO: { primary: '#5b21b6', secondary: '#7c3aed', text: '#ffffff', group: 'AC', groupName: '独立创造' },
  ACED: { primary: '#5b21b6', secondary: '#8b5cf6', text: '#ffffff', group: 'AC', groupName: '独立创造' },
  ACEO: { primary: '#6d28d9', secondary: '#8b5cf6', text: '#ffffff', group: 'AC', groupName: '独立创造' },

  // RS组（深湖蓝+湖蓝）- 专业协作
  RSID: { primary: '#0369a1', secondary: '#0ea5e9', text: '#ffffff', group: 'RS', groupName: '专业协作' },
  RSIO: { primary: '#0284c7', secondary: '#0ea5e9', text: '#ffffff', group: 'RS', groupName: '专业协作' },
  RSED: { primary: '#0369a1', secondary: '#38bdf8', text: '#ffffff', group: 'RS', groupName: '专业协作' },
  RSEO: { primary: '#0284c7', secondary: '#38bdf8', text: '#ffffff', group: 'RS', groupName: '专业协作' },

  // RC组（玫瑰粉+珊瑚橙）- 温暖亲和
  RCID: { primary: '#e11d48', secondary: '#f97316', text: '#ffffff', group: 'RC', groupName: '温暖亲和' },
  RCIO: { primary: '#f43f5e', secondary: '#f97316', text: '#ffffff', group: 'RC', groupName: '温暖亲和' },
  RCED: { primary: '#f43f5e', secondary: '#f97316', text: '#ffffff', group: 'RC', groupName: '温暖亲和' },
  RCEO: { primary: '#fda4af', secondary: '#f97316', text: '#1f2937', group: 'RC', groupName: '温暖亲和' },
}

// 组的配色
export const GROUP_COLORS: Record<'AS' | 'AC' | 'RS' | 'RC', {
  primary: string
  secondary: string
  name: string
  bgClass: string
  borderClass: string
  textClass: string
}> = {
  AS: { primary: '#475569', secondary: '#1e293b', name: '独立探索', bgClass: 'bg-slate-100', borderClass: 'border-slate-500', textClass: 'text-slate-700' },
  AC: { primary: '#5b21b6', secondary: '#7c3aed', name: '独立创造', bgClass: 'bg-violet-100', borderClass: 'border-violet-500', textClass: 'text-violet-700' },
  RS: { primary: '#0369a1', secondary: '#0ea5e9', name: '专业协作', bgClass: 'bg-amber-50', borderClass: 'border-amber-500', textClass: 'text-amber-700' },
  RC: { primary: '#e11d48', secondary: '#f97316', name: '温暖亲和', bgClass: 'bg-rose-50', borderClass: 'border-rose-400', textClass: 'text-rose-600' },
}

export function getTypeColor(code: TypeCode): TypeColorConfig {
  return TYPE_COLORS[code]
}

export function getTypeGroup(code: TypeCode): 'AS' | 'AC' | 'RS' | 'RC' {
  return TYPE_COLORS[code].group
}

export function getGroupColors(group: 'AS' | 'AC' | 'RS' | 'RC') {
  return GROUP_COLORS[group]
}
